<template>
  <v-card elevation="0" :height="($vuetify.breakpoint.xsOnly) ? '810px' : '680px'">

    <v-row class="ma-0 pa-0">
      <!-- Regress -->
      <v-col xl="12" lg="12" md="12" sm="12" cols="12" class="ma-0 pa-0 pl-3">
       <v-switch v-model="form.regress"
          label="Trata-se de uma reconsulta?"
        />
      </v-col>
    </v-row>
    <!-- Urgency -->
    <v-row class="ma-0 pa-0">
      <v-col xl="8" lg="9" md="9" sm="10" cols="12" class="ma-0 pa-0 pl-3">
        <v-subheader class="ma-0 pa-0 mb-5">Nível de urgência</v-subheader>
        <v-slider class="ma-0 pa-0 mb-9 pr-4"
          v-model="urgency.val"
          thumb-label="always"
          min="0" max="3"
          :tick-labels="urgency.labels"
          ticks="always" tick-size="4"
          @input="inputUrgency"
        >
        <template v-slot:thumb-label="props">
          <div>{{ getUrgencyLabel(props.value) }}</div>
        </template>
        </v-slider>
      </v-col>
    </v-row>
    <!-- Time Interval -->
    <ValidationObserver ref="observer">
      <v-row class="ma-0 pa-0">
        <v-col xl="8" lg="9" md="9" sm="10" cols="12" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0">
            <v-col xl="6" lg="6" md="6" sm="6" cols="12" class="ma-0 pa-0 pl-3">
              <mb-time
                v-model="form.timeStart"
                name="timeStart"
                label="Horário Inicial"
                :max="form.timeEnd"
              />
            </v-col>
            <v-col  xl="6" lg="6" md="6" sm="6" cols="12" class="ma-0 pa-0 pl-3">
              <mb-time
                v-model="form.timeEnd"
                name="timeEnd"
                label="Horário Final"
                rules="timeAfter:@timeStart"
                :min="form.timeStart"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
    <!-- Weekdays -->
    <v-row class="ma-0 pa-0">
      <v-col xl="12" lg="12" md="12" sm="12" cols="12" class="ma-0 pa-0 pl-3">
        <week-days-picker v-model="form.weekdays" label="Dias da semana:" />
      </v-col>
    </v-row>
    <!-- Localization -->
    <v-row class="ma-0 pa-0 ml-4">
      <v-col cols="12" class="ma-0 pa-0 mt-5">
        Distância:
      </v-col>
      <v-col xl="5" lg="5" md="6" sm="6" cols="12" class="ma-0 pa-0">
        <v-switch
          v-model="currentLocation"
          :disabled="currentLocationDisabled"
          label="Buscar baseando-se na minha localização?"
          class="pb-2"
          :loading="currentLocationLoading"
        />
      </v-col>
      <v-col v-if="!currentLocation"
        xl="4" lg="4" md="4" sm="4" cols="12" class="ma-0 pa-0 pr-1 pt-2">
        <mb-text-button name="cf_ref_address" v-if="!currentLocation" class="mb-5"
          label="Escolher Endereço" @click="showLocationPicker = true" />
        <v-dialog v-model="showLocationPicker" fullscreen >
          <location-picker v-model="marker"
            @close="showLocationPicker = false" @ok="showLocationPicker = false"/>
        </v-dialog>
      </v-col>
    </v-row>
    <!-- Distance -->
    <v-row class="ma-0 pa-0" v-if="form.latitude && form.longitude">
      <v-col xl="8" lg="9" md="9" sm="10" cols="12" class="ma-0 pa-0 pl-3" >
        <v-subheader class="ma-0 pa-0 mb-5">Distância máxima (km)</v-subheader>
        <v-slider class="ma-0 pa-0 mt-4"
          v-model="form.distance"
          thumb-label="always"
          tick-size="1"
          min="1" max="100"
        >
        </v-slider>
      </v-col>
    </v-row>
    <!-- Buttons -->
    <v-card-actions>
      <mb-text-button name="cf_ref_search" label="Procurar"
        icon="mdi-magnify" :disabled="finishBtnDisabled" @click="finish"/>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import bus from '@/plugins/eventBus';
import MbTextButton from '@/components/general/buttons/MbTextButton';
import MbTime from '@/components/general/inputs/MbTime';
import WeekDaysPicker from '@/components/general/inputs/WeekDaysPicker';
import LocationPicker from '@/components/general/inputs/LocationPicker';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    form: {
      regress: false,
      dateStart: null,
      dateEnd: null,
      timeStart: null,
      timeEnd: null,
      weekdays: null,
      latitude: null,
      longitude: null,
      distance: null,
    },
    urgency: {
      val: 3,
      labels: ['hoje', '3 dias', '7 dias', '...'],
      ticksLabels: ['hoje', '3d', '7d', '...'],
    },
    currentLocation: false,
    currentLocationDisabled: false,
    marker: null,
    showLocationPicker: false,
    currentLocationLoading: false,
    finishBtnDisabled: false,
  }),
  created() {
    this.urgency.val = (this.value && this.value.urgency) ? this.value.urgency : 3;
    this.form.distance = (this.value && this.value.distance) ? this.value.distance : 100;
    this.form.dateStart = this.$moment().format('YYYY-MM-DD');
  },
  methods: {
    getUrgencyLabel() {
      return this.urgency.ticksLabels[this.form.urgency];
    },
    inputUrgency() {
      if (this.urgency.val === 0) {
        this.form.dateEnd = this.$moment().format('YYYY-MM-DD');
      } else if (this.urgency.val === 1) {
        this.form.dateEnd = this.$moment().add(3, 'days').format('YYYY-MM-DD');
      } else if (this.urgency.val === 2) {
        this.form.dateEnd = this.$moment().add(7, 'days').format('YYYY-MM-DD');
      } else if (this.urgency.val === 3) {
        this.form.dateEnd = null;
      }
    },
    async finish() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.$emit('finish');
      }
    },
    getCurrentLocation() {
      this.finishBtnDisabled = true;
      this.currentLocationLoading = true;
      // do we support geolocation
      if (!('geolocation' in navigator)) {
        bus.$emit('message', { message: 'Seu navegador não suporta geolocalização', type: 'warn' });
        this.currentLocationDisabled = true;
        this.finishBtnDisabled = false;
        this.currentLocationLoading = false;
        return;
      }

      // get position
      navigator.geolocation.getCurrentPosition((pos) => {
        this.form.latitude = pos.coords.latitude;
        this.form.longitude = pos.coords.longitude;
        this.finishBtnDisabled = false;
        this.currentLocationLoading = false;
      }, () => {
        this.currentLocation = false;
        bus.$emit('message', { message: 'Você negou permissão à geolocalização', type: 'error' });
        this.finishBtnDisabled = false;
        this.currentLocationLoading = false;
      });
    },
  },
  watch: {
    currentLocation(vl) {
      console.log(`currentLocation: ${vl}`);
      if (vl === true) {
        this.getCurrentLocation();
      } else if (!this.marker) {
        this.form.latitude = null;
        this.form.longitude = null;
      }
    },
    marker(vl) {
      if (vl) {
        this.form.latitude = vl.lat;
        this.form.longitude = vl.lng;
      }
    },
    form: {
      handler() {
        this.$emit('input', this.form);
      },
      deep: true,
    },
  },
  components: {
    ValidationObserver,
    MbTextButton,
    MbTime,
    WeekDaysPicker,
    LocationPicker,
  },
};
</script>
